module.exports = __webpack_public_path__ + "static/media/obestinado_b.9f73ed1d.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/badges/obestinado_b.png
// module id = 1149
// module chunks = 0